import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../Components/Loader";
import "../../Styles/ManageUsersAdmin.css";

function ManageUsersAdmin() {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(15);

  useEffect(() => {
    const fetchUsers = async () => {
      const authToken = localStorage.getItem("authToken");

      try {
        setLoading(true);
        const response = await axios.get("https://api.uniums.com/api/admin/manage-users", {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        setUsers(response.data.data);
        setFilteredUsers(response.data.data);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.error || "Failed to fetch users.");
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = users.filter((user) => {
      return (
        user.name.toLowerCase().includes(value) ||
        user.email.toLowerCase().includes(value) ||
        user.organizationAddress?.toLowerCase().includes(value)
      );
    });

    setFilteredUsers(filtered);
    setCurrentPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const toggleStatus = async (userId) => {
    const authToken = localStorage.getItem("authToken");

    try {
      const response = await axios.put(`https://api.uniums.com/api/admin/update-status/${userId}`, {}, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      const updatedUsers = users.map((user) =>
        user._id === userId ? { ...user, active: response.data.user.active } : user
      );

      setUsers(updatedUsers);
      setFilteredUsers(updatedUsers); 
    } catch (err) {
      setError("Failed to update user status");
    }
  };

  return (
    <div className="DeactivateUsers_container">
      <h1>Manage Your Users</h1>
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by Name, Email, or Organization"
          value={searchTerm}
          onChange={handleSearch}
          className="search-box"
        />
      </div>

      {loading ? (
        <Loader />
      ) : (
        <div className="admin-table-container">
          {error ? (
            <div className="error">{error}</div>
          ) : (
            <>
              <table className="DeactivateUsers_table">
                <thead>
                  <tr>
                    <th>SL No</th>
                    <th>Name</th>
                    <th>Emp. Type</th>
                    <th>Email</th>
                    <th>Organization Address</th>
                    <th>Contact</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((user, index) => (
                      <tr key={user._id}>
                        <td>{index + 1}</td>
                        <td>{user.name}</td>
                        <td>{user.role}</td>
                        <td>{user.email}</td>
                        <td>{user.organizationAddress}</td>
                        <td>{user.organizationContact}</td>
                        <td className="table_btn_td">
                          <button
                            className="active-btn"
                            onClick={() => toggleStatus(user._id)}
                            disabled={user.active}
                          >
                            Active
                          </button>
                          <button
                            className="block-btn"
                            onClick={() => toggleStatus(user._id)}
                            disabled={!user.active}
                          >
                            Block
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="error">No Data Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="pagination">
                {filteredUsers.length > itemsPerPage && (
                  <ul className="pagination-list">
                    {[...Array(Math.ceil(filteredUsers.length / itemsPerPage))].map((_, index) => (
                      <li key={index + 1}>
                        <button
                          className={`page-btn ${currentPage === index + 1 ? "active" : ""}`}
                          onClick={() => paginate(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default ManageUsersAdmin;
